import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Alert } from 'antd';
import { actions as newRequestActions } from '../../../CreateRequest/new-request.actions';
import { requestsActions } from '../../requests.actions';

const SuccessRequestCreation = () => {
  const dispatch = useDispatch();

  const postedRequestId = useSelector(
    (state) => state.newRequestStore.postRequestID
  );

  const handleClose = () => {
    dispatch(newRequestActions.resetPostedRequest());
    dispatch(requestsActions.fetchRequests());
  };

  return (
    <Alert
      banner
      closable
      type="success"
      showIcon={false}
      onClose={handleClose}
      message={`Заявка создана под номером ${postedRequestId}`}
      description="Проверьте детали заявки и внесите необходимые дополнения"
    />
  );
};

export default SuccessRequestCreation;
